document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[class*="ingredient-section-"]').forEach(section => {
    const tabBtns = section.querySelectorAll('[class*="ingredient-tab-btn-"]');
    const tabPanes = section.querySelectorAll('[class*="ingredient-tab-pane-"]');

    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        tabBtns.forEach(b => b.classList.remove('active'));
        tabPanes.forEach(p => p.classList.remove('active'));

        btn.classList.add('active');

        const targetId = btn.getAttribute('data-target');
        const targetPane = document.getElementById(targetId);
        if (targetPane) {
          targetPane.classList.add('active');
        }
      });
    });
  });
});
